export default __webpack_public_path__ + "static/media/section2-img1.8394b26e.png";